import type { AnyFunction, ReadonlyRecord } from './Types'

export const nameFunction = <F extends AnyFunction, N extends string>(func: F, functionName: N): F => {
    const aux = { [functionName]: (...args: unknown[]) => func(...args) } as ReadonlyRecord<N, F>
    return aux[functionName]
}
